import TuneIcon from '@mui/icons-material/Tune';
import { Button, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { memo } from 'react';
import { BOTTOM_BAR_HEIGHT } from '/@/components/app-navbar/bottombar';
import { _ } from '/@/locale';

type MobileFilterBarProps = {
    activeFilterCount: number;
    includeFields: boolean;
    onFilterClick: () => void;
    onIncludeFieldsChange: (value: boolean) => void;
};

const MobileFilterBar = memo(function MobileFilterBar({
    activeFilterCount,
    includeFields,
    onFilterClick,
    onIncludeFieldsChange,
}: MobileFilterBarProps) {
    const filterLabel = activeFilterCount > 0 ? `${_('Filtrar')} (${activeFilterCount})` : _('Filtrar');

    return (
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='center'
            gap={2}
            px={2}
            py={1}
            width='100%'
            bgcolor='background.paper'
            borderTop={(t) => `1px solid ${t.palette.divider}`}
            position='absolute'
            bottom={{ xs: BOTTOM_BAR_HEIGHT, sm: 0 }}
            zIndex={1}
        >
            <Button variant='contained' color='secondary' startIcon={<TuneIcon />} onClick={onFilterClick}>
                {filterLabel}
            </Button>
            <FormControlLabel
                control={
                    <Switch
                        checked={includeFields}
                        onChange={(_, checked) => onIncludeFieldsChange(checked)}
                        color='info'
                    />
                }
                label={
                    <Typography variant='body2' color='info'>
                        {_('Mostrar lotes')}
                    </Typography>
                }
                sx={{ m: 0 }}
            />
        </Stack>
    );
});

export default MobileFilterBar;
